var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form-item',{attrs:{"label":_vm.i18nt('designer.setting.disabled')}},[_c('el-switch',{model:{value:(_vm.optionModel.disabled),callback:function ($$v) {_vm.$set(_vm.optionModel, "disabled", $$v)},expression:"optionModel.disabled"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }